/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';
import { UpdateBuchungDto } from '../../models/update-buchung-dto';

export interface UpdateOneBuchung$Plain$Params {

/**
 * ID der Buchung die aktualisiert werden soll
 */
  buchungsId: string;
  
    /**
     * Aktualisierte Daten für die Buchung
     */
    body?: UpdateBuchungDto
}

export function updateOneBuchung$Plain(http: HttpClient, rootUrl: string, params: UpdateOneBuchung$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungDto>> {
  const rb = new RequestBuilder(rootUrl, updateOneBuchung$Plain.PATH, 'put');
  if (params) {
    rb.path('buchungsId', params.buchungsId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungDto>;
    })
  );
}

updateOneBuchung$Plain.PATH = '/v1/buchungen/{buchungsId}';
